export const SET_OPTIONS_LIST_SUCCESS = 'SET_OPTIONS_SUCCESS'
